import { render, staticRenderFns } from "./relieveNot.vue?vue&type=template&id=516c06b5&scoped=true&"
import script from "./relieveNot.vue?vue&type=script&lang=js&"
export * from "./relieveNot.vue?vue&type=script&lang=js&"
import style0 from "./relieveNot.vue?vue&type=style&index=0&id=516c06b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c06b5",
  null
  
)

export default component.exports